import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesPerSlide, setImagesPerSlide] = useState(4);
  
  // Update images per slide based on screen width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setImagesPerSlide(1); // Small phones: 1 image
      } else if (window.innerWidth <= 768) {
        setImagesPerSlide(1); // Mobile: 1 image
      } else if (window.innerWidth <= 1024) {
        setImagesPerSlide(2); // Tablet: 2 images
      } else {
        setImagesPerSlide(4); // Desktop: 4 images
      }
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const totalSlides = Math.ceil(images.length / imagesPerSlide);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  };

  const getCurrentImages = () => {
    const startIdx = currentIndex * imagesPerSlide;
    return images.slice(startIdx, startIdx + imagesPerSlide);
  };

  return (
    <div className="image-carousel">
      <div className="carousel-container">
        <button 
          className="carousel-button carousel-button--prev" 
          onClick={goToPrevious}
          aria-label="Previous images"
        >
          ‹
        </button>
        
        <div className="carousel-images-wrapper">
          {getCurrentImages().map((image, idx) => (
            <div key={idx} className="carousel-image-container">
              <img 
                src={image} 
                alt={`Event ${currentIndex * imagesPerSlide + idx + 1}`}
                className="carousel-image"
              />
            </div>
          ))}
        </div>

        <button 
          className="carousel-button carousel-button--next" 
          onClick={goToNext}
          aria-label="Next images"
        >
          ›
        </button>
      </div>

      <div className="carousel-dots">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
